import { buildApiUrl } from '../utils/apiSetup';
const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
  if (json) headers['Content-Type'] = 'application/json';
  return headers;
};

const parseError = async (response, fallback) => {
  try {
    const data = await response.json();
    if (typeof data.detail === 'string') return data.detail;
  } catch {
    /* ignore */
  }
  return fallback;
};

export async function fetchGovernanceOverview(signal) {
  const response = await fetch(buildApiUrl('/api/v1/governance/overview'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load governance overview'));
  return response.json();
}

export async function fetchPenaltyKpis(signal) {
  const response = await fetch(buildApiUrl('/api/v1/employee-penalties/kpis'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load penalty KPIs'));
  return response.json();
}

export async function fetchPenaltyRules(params, signal) {
  const searchParams = new URLSearchParams({ paginated: 'true', page_size: '10', ...params });
  const response = await fetch(buildApiUrl(`/api/v1/penalties?${searchParams}`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load penalty rules'));
  return response.json();
}

export async function savePenaltyRule(rule, signal) {
  const { id, ...payload } = rule;
  const method = id ? 'PUT' : 'POST';
  const endpoint = id ? `/api/v1/penalties/${id}` : '/api/v1/penalties/create';
  const response = await fetch(endpoint, {
    method,
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to save penalty rule'));
  return response.json();
}

export async function deletePenaltyRule(ruleId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/penalties/${ruleId}`), {
    method: 'DELETE',
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to delete penalty rule'));
  return response.json();
}

export async function fetchEmployeePenalties(page, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee-penalties?page=${page}&page_size=10`), {
    headers: authHeaders(false),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee penalties'));
  return response.json();
}

export async function fetchLeavePolicies(params, signal) {
  const searchParams = new URLSearchParams({ page_size: '20', ...params });
  const response = await fetch(buildApiUrl(`/api/v1/leaves/policies?${searchParams}`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load leave policies'));
  return response.json();
}

export async function fetchEmployeeMasters(signal) {
  const response = await fetch(buildApiUrl('/api/v1/employee-master/masters/all'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load governance masters'));
  return response.json();
}

export async function fetchShifts(activeOnly = true, signal) {
  const url = activeOnly ? '/api/v1/shifts/?is_active=true' : '/api/v1/shifts/';
  const response = await fetch(buildApiUrl(url), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load shifts'));
  return response.json();
}

export async function fetchTaxConfigurations(signal) {
  const response = await fetch(buildApiUrl('/api/v1/governance/tax-configurations'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load tax configurations'));
  return response.json();
}

export async function saveTaxConfiguration(config, signal) {
  const { id, ...payload } = config;
  const method = id ? 'PUT' : 'POST';
  const endpoint = id ? `/api/v1/governance/tax-configurations/${id}` : '/api/v1/governance/tax-configurations';
  const response = await fetch(endpoint, {
    method,
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to save tax configuration'));
  return response.json();
}
